// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as $$Promise from "../../../node_modules/@ryyppy/rescript-promise/lib/es6_global/src/Promise.bs.js";
import * as Belt_Array from "../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../node_modules/rescript/lib/es6/caml_option.js";
import * as UseSafeTimeout from "../../../node_modules/@makerinc/use-safe-timeout/lib/es6_global/src/UseSafeTimeout.bs.js";
import * as Facets$Showside from "./types/Facets.bs.js";
import * as UseEnv$Showside from "./hook/UseEnv.bs.js";
import * as Product$Showside from "./types/Product.bs.js";
import * as Category$Showside from "./types/Category.bs.js";
import * as URLUtils$Showside from "./utils/URLUtils.bs.js";
import * as Favorites$Showside from "./components/Favorites.bs.js";
import * as UseMarkets$Showside from "./hook/UseMarkets.bs.js";
import * as UseSidebar$Showside from "./hook/UseSidebar.bs.js";
import * as UseTracking$Showside from "./hook/UseTracking.bs.js";
import * as CustomScript$Showside from "./utils/CustomScript.bs.js";
import * as UseAddToCart2$Showside from "./hook/UseAddToCart2.bs.js";
import * as RouterProvider$Showside from "./context/RouterProvider.bs.js";
import * as GoogleAnalytics$Showside from "./utils/GoogleAnalytics.bs.js";
import * as RollbarInstance$Showside from "./utils/RollbarInstance.bs.js";
import * as ViewportContext$Showside from "./context/ViewportContext.bs.js";
import * as EntrypointContext$Showside from "./context/EntrypointContext.bs.js";
import * as CartContextProvider$Showside from "./context/CartContextProvider.bs.js";
import * as ExternalIntegrationProvider$Showside from "./context/ExternalIntegrationProvider.bs.js";
import * as Store_ProductSortOrderCodecs$ApiTypes from "../../../node_modules/api-types/lib/es6_global/src/Store/Store_ProductSortOrderCodecs.bs.js";
import * as PictureInPicture2SessionStorage$Showside from "./utils/PictureInPicture2SessionStorage.bs.js";
function EntrypointCallbacks(Props) {
  var config = Props.config;
  var embedType = Props.embedType;
  var attributes = Props.attributes;
  var contextualRoot = Props.contextualRoot;
  var onOpeningDrawer = Props.onOpeningDrawer;
  var children = Props.children;
  var match = ViewportContext$Showside.use(undefined);
  var isMobile = match.isMobile;
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var listPageType = match$1.listPageType;
  var reset = match$1.reset;
  var goTo = match$1.goTo;
  var back = match$1.back;
  var route = match$1.route;
  var activeCategory = RouterProvider$Showside.useActiveCategory(undefined, undefined, config.categories);
  var match$2 = ExternalIntegrationProvider$Showside.use(undefined);
  var externalOnOpenLink = match$2.onOpenLink;
  var match$3 = UseEnv$Showside.use(undefined);
  var smartnavApiHost = match$3.smartnavApiHost;
  var trackEvent = UseTracking$Showside.use(embedType);
  var match$4 = React.useState(function () {});
  var setLastProductAddedToCart = match$4[1];
  var lastProductAddedToCart = match$4[0];
  var match$5 = UseSidebar$Showside.useSidebarState(undefined);
  var setIsSidebarOpen = match$5[1];
  var isSidebarOpen = match$5[0];
  var match$6 = React.useState(function () {
    return false;
  });
  var setIsMobileFiltersOpen = match$6[1];
  var isMobileFiltersOpen = match$6[0];
  var isMiniPDPVisible = React.useRef(false);
  var match$7 = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var lastProductAddedToCartTimeout = match$7.setTimeout;
  var addToCart = UseAddToCart2$Showside.useAddToCart(config.id, smartnavApiHost);
  var match$8 = CartContextProvider$Showside.useCart(undefined);
  var activeCategoryTitle = Belt_Option.mapWithDefault(activeCategory, "", function (cat) {
    return cat.title;
  });
  var onAddToCart = React.useCallback(function (product) {
    return function (variant, quantity, category) {
      var tmp;
      tmp = typeof route === "number" || route.TAG !== /* QuickView */3 ? undefined : route._0.mediaId;
      Curry.app(trackEvent, ["product details:add to cart", undefined, undefined, product, variant, undefined, undefined, isMiniPDPVisible.current, tmp, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
      Curry._4(addToCart, product, variant, category, quantity).then(function (input) {
        Curry._1(setLastProductAddedToCart, function (param) {
          return variant;
        });
        lastProductAddedToCartTimeout(function (param) {
          Curry._1(setLastProductAddedToCart, function (param) {});
        }, 3200);
        return Promise.resolve(input);
      });
      return UseTracking$Showside.trackRetargeting(config.transitiveAccount, config.id, category !== undefined ? category : activeCategory, product, variant, isMobile, undefined, undefined, quantity, undefined, undefined, "add_to_cart");
    };
  }, [trackEvent, addToCart, setLastProductAddedToCart, lastProductAddedToCartTimeout, activeCategoryTitle, route]);
  var toggleSidebar = React.useCallback(function (param) {
    Curry._1(setIsSidebarOpen, function (previous) {
      if (previous === false) {
        Curry.app(trackEvent, ["filter expanded", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
      }
      return !previous;
    });
  }, []);
  var toggleFiltersPanel = React.useCallback(function (param) {
    Curry._1(setIsMobileFiltersOpen, function (previous) {
      if (previous === false) {
        Curry.app(trackEvent, ["filter expanded", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
      }
      return !previous;
    });
  }, []);
  var handleHomeClicked = React.useCallback(function (param) {
    var firstCategoryId = Belt_Option.map(Belt_Array.get(config.categories, 0), function (param) {
      return param.id;
    });
    var match = config.settings.indexNode;
    var match$1 = config.settings.mkrBio;
    var destinationRoute = match !== undefined && match$1 !== undefined && firstCategoryId !== undefined && !match.visibleInMenuBar ? {
      TAG: /* ListPage */1,
      _0: {
        listPageType: {
          TAG: /* Category */0,
          _0: firstCategoryId
        },
        viewPLP: false,
        filters: undefined,
        sort: undefined
      }
    } : {
      TAG: /* Home */0,
      _0: {
        homeType: /* Index */0,
        filters: undefined,
        sort: undefined
      }
    };
    Curry._3(goTo, undefined, undefined, destinationRoute);
    Curry.app(trackEvent, ["open index", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
  }, [goTo, trackEvent]);
  var handlePureCategoryClick = function (clearIntentOpt, category) {
    var clearIntent = clearIntentOpt !== undefined ? clearIntentOpt : true;
    var match = category.categoryType;
    var exit = 0;
    if (typeof match === "number" || !(match.TAG === /* QuickView */2 && match._0.products.length !== 0)) {
      exit = 1;
    } else {
      Curry.app(trackEvent, ["slider:promo", true, category, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    }
    if (exit === 1) {
      Curry.app(trackEvent, ["slider:category", true, category, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    }
    Curry._3(goTo, clearIntent, undefined, {
      TAG: /* ListPage */1,
      _0: {
        listPageType: {
          TAG: /* Category */0,
          _0: category.id
        },
        viewPLP: false,
        filters: undefined,
        sort: undefined
      }
    });
  };
  var handleCategoryClick = React.useCallback(function (category) {
    var match = category.categoryType;
    var exit = 0;
    if (typeof match === "number" || !(match.TAG === /* QuickView */2 && match._0.products.length !== 0)) {
      exit = 1;
    } else {
      Curry.app(trackEvent, ["slider:promo", true, category, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    }
    if (exit === 1) {
      Curry.app(trackEvent, ["slider:category", true, category, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    }
    var match$1 = category.categoryType;
    var match$2 = Category$Showside.Link.getCardLink(category);
    var exit$1 = 0;
    var exit$2 = 0;
    if (match$2 !== undefined) {
      if (match$2.TAG === /* CustomAction */4) {
        var match$3 = match$2._0;
        CustomScript$Showside.triggerCustomFunctionWithoutProducts(match$3.code, match$3.name, undefined, undefined);
        return;
      }
      exit$2 = 3;
    } else {
      exit$2 = 3;
    }
    if (exit$2 === 3) {
      if (typeof match$1 === "number") {
        exit$1 = 2;
      } else {
        switch (match$1.TAG | 0) {
          case /* Link */0:
            if (match$2 !== undefined) {
              if (match$2.TAG === /* URL */0) {
                return;
              }
              exit$1 = 2;
            }
            break;
          case /* QuickView */2:
            if (Category$Showside.hasProducts(category)) {
              return Curry._3(goTo, undefined, undefined, {
                TAG: /* QuickView */3,
                _0: {
                  mediaId: category.id,
                  mediaParentId: undefined,
                  albumId: undefined,
                  productId: undefined,
                  relatedMediaProductIds: undefined,
                  relatedMediaCategoryId: undefined,
                  variantId: undefined,
                  panelClosed: undefined,
                  zoomedPhotoIndex: undefined,
                  time: undefined
                }
              });
            }
            exit$1 = 2;
            break;
          case /* Index */3:
            return Curry._1(handleHomeClicked, undefined);
          default:
            exit$1 = 2;
        }
      }
    }
    if (exit$1 === 2 && match$2 !== undefined) {
      switch (match$2.TAG | 0) {
        case /* URL */0:
          break;
        case /* Category */1:
          var match$4 = match$2._0;
          return Curry._3(goTo, undefined, undefined, {
            TAG: /* ListPage */1,
            _0: {
              listPageType: {
                TAG: /* Category */0,
                _0: match$4.categoryId
              },
              viewPLP: false,
              filters: match$4.filters,
              sort: undefined
            }
          });
        case /* Product */2:
          var match$5 = match$2._0;
          return Curry._3(goTo, undefined, undefined, {
            TAG: /* PDP */2,
            _0: {
              categoryId: RouterProvider$Showside.getListPageCategoryId(route),
              productCategoryId: match$5.productCategoryId,
              productId: match$5.productId,
              variantId: match$5.variantId,
              zoomedPhotoIndex: undefined
            }
          });
        case /* StoreCategory */3:
          var match$6 = match$2._0;
          return Curry._3(goTo, undefined, undefined, {
            TAG: /* ListPage */1,
            _0: {
              listPageType: {
                TAG: /* StoreCategory */2,
                _0: {
                  categoryId: match$6.categoryId,
                  sourceNodeId: category.id
                }
              },
              viewPLP: false,
              filters: undefined,
              sort: match$6.sortBy
            }
          });
      }
    }
    Curry._3(goTo, undefined, undefined, {
      TAG: /* ListPage */1,
      _0: {
        listPageType: {
          TAG: /* Category */0,
          _0: category.id
        },
        viewPLP: false,
        filters: undefined,
        sort: undefined
      }
    });
  }, [listPageType, handleHomeClicked, trackEvent]);
  var handleQuickViewClick = React.useCallback(function (parentCategory) {
    return function (category) {
      return Curry._3(goTo, undefined, undefined, {
        TAG: /* QuickView */3,
        _0: {
          mediaId: category.id,
          mediaParentId: Belt_Option.map(parentCategory, function (c) {
            return c.id;
          }),
          albumId: undefined,
          productId: undefined,
          relatedMediaProductIds: undefined,
          relatedMediaCategoryId: undefined,
          variantId: undefined,
          panelClosed: undefined,
          zoomedPhotoIndex: undefined,
          time: undefined
        }
      });
    };
  }, [goTo]);
  var handleCloseNavigation = React.useCallback(function (param) {
    Curry.app(trackEvent, ["exit click", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    Curry._1(reset, undefined);
  }, [reset]);
  var handleProductClick = React.useCallback(function (product) {
    return function (variant) {
      Curry.app(trackEvent, ["slider:item", true, undefined, product, variant, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
      if (typeof route !== "number" && route.TAG === /* QuickView */3) {
        var payload = route._0;
        return Curry._3(goTo, undefined, undefined, {
          TAG: /* QuickView */3,
          _0: {
            mediaId: payload.mediaId,
            mediaParentId: payload.mediaParentId,
            albumId: payload.albumId,
            productId: product.id,
            relatedMediaProductIds: payload.relatedMediaProductIds,
            relatedMediaCategoryId: payload.relatedMediaCategoryId,
            variantId: Belt_Option.map(variant, function (v) {
              return v.id;
            }),
            panelClosed: payload.panelClosed,
            zoomedPhotoIndex: payload.zoomedPhotoIndex,
            time: payload.time
          }
        });
      }
      return Curry._3(goTo, undefined, undefined, {
        TAG: /* PDP */2,
        _0: {
          categoryId: Belt_Option.flatMap(listPageType, function (id) {
            if (typeof id === "number" || id.TAG !== /* Category */0) {
              return;
            } else {
              return id._0;
            }
          }),
          productCategoryId: product.categoryId,
          productId: product.id,
          variantId: Belt_Option.map(variant, function (v) {
            return v.id;
          }),
          zoomedPhotoIndex: undefined
        }
      });
    };
  }, [config.id, listPageType, RouterProvider$Showside.toString(route), trackEvent]);
  var handleBackClick = function (param) {
    var parent = Category$Showside.getCategoryParentById(config.categories, Belt_Option.mapWithDefault(listPageType, "", function (id) {
      if (typeof id === "number" || id.TAG !== /* Category */0) {
        return "";
      } else {
        return id._0;
      }
    }));
    if (typeof route !== "number" && route.TAG === /* ListPage */1) {
      var listPageRoute = route._0;
      if (listPageRoute.viewPLP) {
        return Curry._3(goTo, undefined, undefined, {
          TAG: /* ListPage */1,
          _0: {
            listPageType: listPageRoute.listPageType,
            viewPLP: false,
            filters: undefined,
            sort: undefined
          }
        });
      }
      if (parent !== undefined) {
        return Curry._3(goTo, undefined, undefined, {
          TAG: /* ListPage */1,
          _0: {
            listPageType: {
              TAG: /* Category */0,
              _0: parent.id
            },
            viewPLP: false,
            filters: undefined,
            sort: undefined
          }
        });
      }
    }
    var isHome;
    isHome = typeof route === "number" || route.TAG !== /* Home */0 ? false : true;
    if (isHome) {
      Curry.app(trackEvent, ["back button", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    }
    Curry._1(back, undefined);
  };
  var getLinkerParam = function (param) {
    return new Promise(function (resolve, reject) {
      var timeout = setTimeout(function (param) {
        resolve(undefined);
      }, 500);
      $$Promise.$$catch(GoogleAnalytics$Showside.getLinkerParam(config.settings.gaTrackingId, config.settings.gaVersion, config.settings.checkoutLink, config.transitiveAccount, undefined), function (param) {
        return Promise.resolve(undefined);
      }).then(function (linkerParam) {
        clearTimeout(timeout);
        resolve(linkerParam);
      });
    }).then(function (linkerParam) {
      var match = config.settings.gaTrackingId;
      if (match !== undefined && linkerParam !== undefined) {
        return linkerParam;
      }
    });
  };
  var appendQueryParams = function (url) {
    var transformedUrl = URLUtils$Showside.maybeMakeUrl(URLUtils$Showside.resolveRelativePath(URLUtils$Showside.addProtocolIfMissing(url)));
    if (transformedUrl === undefined) {
      return Promise.resolve(url);
    }
    var url$1 = Caml_option.valFromOption(transformedUrl);
    var params = url$1.searchParams;
    var urlHasUtmParams = params.has("utm_source");
    var existingUtmParams = Belt_Array.keep(Array.from(new URL(window.location.href).searchParams.entries()), function (param) {
      return param[0].includes("utm_");
    });
    var hasExistingUtmParams = existingUtmParams.length !== 0;
    var match = config.settings.mkrBio;
    if (hasExistingUtmParams) {
      if (urlHasUtmParams) {} else {
        Belt_Array.forEach(existingUtmParams, function (param) {
          params.append(param[0], param[1]);
        });
      }
    } else if (match !== undefined && !urlHasUtmParams) {
      params.append("utm_medium", "referral");
      params.append("utm_source", "mkr.bio");
      params.append("utm_campaign", "mkr.bio");
    }
    return getLinkerParam(undefined).then(function (linkerParam) {
      if (linkerParam !== undefined) {
        params.append(linkerParam[0], linkerParam[1]);
      }
      return url$1.href;
    });
  };
  var redirectToLink = function (category, product, variant, openLinkInNewTabOpt, url) {
    var openLinkInNewTab = openLinkInNewTabOpt !== undefined ? openLinkInNewTabOpt : false;
    var url$1 = URLUtils$Showside.maybeMakeRelativeUrl(url);
    var tmp;
    tmp = typeof route === "number" || route.TAG !== /* QuickView */3 ? undefined : route._0.mediaId;
    Curry.app(trackEvent, ["open link", undefined, category, product, variant, undefined, undefined, undefined, tmp, undefined, undefined, undefined, undefined, undefined, url$1, undefined]);
    appendQueryParams(url$1).then(function (url) {
      if (openLinkInNewTab) {
        window.open(url, "_blank");
      } else {
        window.top.location.href = url;
      }
    });
  };
  var handleOpenLink = function (category, index, product, variant, param) {
    var variant$1 = Belt_Option.getWithDefault(variant, product.firstVariant);
    UseTracking$Showside.trackRetargeting(config.transitiveAccount, config.id, category, product, variant$1, isMobile, index, undefined, 1, undefined, undefined, "select_item");
    PictureInPicture2SessionStorage$Showside.storeLastCategory(route);
    if (externalOnOpenLink !== undefined) {
      var tmp;
      tmp = typeof route === "number" || route.TAG !== /* QuickView */3 ? undefined : route._0.mediaId;
      Curry.app(trackEvent, ["open link", undefined, undefined, product, variant$1, undefined, undefined, undefined, tmp, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
      return Curry._1(externalOnOpenLink, Product$Showside.toLegacyDTO(product, variant$1));
    }
    var match = variant$1.link;
    var match$1 = product.link;
    if (match !== undefined) {
      return redirectToLink(undefined, product, variant$1, undefined, match);
    } else if (match$1 !== undefined) {
      return redirectToLink(undefined, product, variant$1, undefined, match$1);
    } else {
      RollbarInstance$Showside.error1(RollbarInstance$Showside.makeError(true, "Couldn't open link because neither product " + product.id + " nor variant " + variant$1.id + " have a link."));
      return;
    }
  };
  var favoritesLink = Favorites$Showside.useFavoritesLink(undefined);
  var handleFavoritesClicked = React.useCallback(function (param) {
    if (favoritesLink !== undefined) {
      return redirectToLink(undefined, undefined, undefined, undefined, favoritesLink);
    }
    var destinationRoute;
    if (typeof route === "number") {
      destinationRoute = {
        TAG: /* Home */0,
        _0: {
          homeType: /* Favorites */1,
          filters: undefined,
          sort: undefined
        }
      };
    } else {
      switch (route.TAG | 0) {
        case /* ListPage */1:
          destinationRoute = {
            TAG: /* ListPage */1,
            _0: {
              listPageType: /* Favorites */0,
              viewPLP: route._0.viewPLP,
              filters: undefined,
              sort: undefined
            }
          };
          break;
        case /* PDP */2:
          destinationRoute = route._0.categoryId !== undefined ? {
            TAG: /* ListPage */1,
            _0: {
              listPageType: /* Favorites */0,
              viewPLP: false,
              filters: undefined,
              sort: undefined
            }
          } : {
            TAG: /* Home */0,
            _0: {
              homeType: /* Favorites */1,
              filters: undefined,
              sort: undefined
            }
          };
          break;
        default:
          destinationRoute = {
            TAG: /* Home */0,
            _0: {
              homeType: /* Favorites */1,
              filters: undefined,
              sort: undefined
            }
          };
      }
    }
    Curry._3(goTo, undefined, undefined, destinationRoute);
  }, [goTo, trackEvent, RouterProvider$Showside.toString(route)]);
  var handleHistoryClicked = React.useCallback(function (param) {
    var destinationRoute;
    if (typeof route === "number") {
      destinationRoute = {
        TAG: /* Home */0,
        _0: {
          homeType: /* History */2,
          filters: undefined,
          sort: undefined
        }
      };
    } else {
      switch (route.TAG | 0) {
        case /* ListPage */1:
          destinationRoute = {
            TAG: /* ListPage */1,
            _0: {
              listPageType: /* History */1,
              viewPLP: route._0.viewPLP,
              filters: undefined,
              sort: undefined
            }
          };
          break;
        case /* PDP */2:
          destinationRoute = route._0.categoryId !== undefined ? {
            TAG: /* ListPage */1,
            _0: {
              listPageType: /* History */1,
              viewPLP: false,
              filters: undefined,
              sort: undefined
            }
          } : {
            TAG: /* Home */0,
            _0: {
              homeType: /* History */2,
              filters: undefined,
              sort: undefined
            }
          };
          break;
        default:
          destinationRoute = {
            TAG: /* Home */0,
            _0: {
              homeType: /* History */2,
              filters: undefined,
              sort: undefined
            }
          };
      }
    }
    Curry._3(goTo, undefined, undefined, destinationRoute);
  }, [goTo, trackEvent, RouterProvider$Showside.toString(route)]);
  var handleLauncherItemClick = React.useCallback(function (category) {
    Curry.app(trackEvent, ["top category nav", true, category, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    var match = category.categoryType;
    if (typeof match === "number" || !(match.TAG === /* QuickView */2 && match._0.isStories)) {
      return Curry._1(handleCategoryClick, category);
    } else {
      return Curry._2(handleQuickViewClick, undefined, category);
    }
  }, [handleCategoryClick, handleQuickViewClick]);
  var handleDrawerOpening = function (param) {
    Belt_Option.forEach(onOpeningDrawer, function (f) {
      Curry._1(f, undefined);
    });
    if (contextualRoot !== undefined) {
      return Curry._1(handleCategoryClick, contextualRoot);
    } else {
      return Curry._1(handleHomeClicked, undefined);
    }
  };
  var handleChangeSort = React.useCallback(function (sort) {
    if (sort !== undefined) {
      Curry.app(trackEvent, [{
        NAME: "sort applied",
        VAL: Store_ProductSortOrderCodecs$ApiTypes.ProductSortOrder.toString(sort)
      }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    }
    var tmp;
    if (typeof route === "number") {
      tmp = route;
    } else {
      switch (route.TAG | 0) {
        case /* Home */0:
          var data = route._0;
          tmp = {
            TAG: /* Home */0,
            _0: {
              homeType: data.homeType,
              filters: data.filters,
              sort: sort
            }
          };
          break;
        case /* ListPage */1:
          var data$1 = route._0;
          tmp = {
            TAG: /* ListPage */1,
            _0: {
              listPageType: data$1.listPageType,
              viewPLP: data$1.viewPLP,
              filters: data$1.filters,
              sort: sort
            }
          };
          break;
        default:
          tmp = route;
      }
    }
    Curry._3(goTo, undefined, true, tmp);
  }, [RouterProvider$Showside.toString(route)]);
  var handleChangeFilters = React.useCallback(function (filters) {
    var isEmpty = filters === undefined || Belt_Option.mapWithDefault(filters, 0, Facets$Showside.length) === 0;
    var filtersNames = Belt_Option.map(filters, function (filters) {
      return Belt_Array.concatMany([Belt_Array.map(filters.entries, function (entry) {
        return entry.facet;
      }), Belt_Option.mapWithDefault(filters.minPrice, [], function (price) {
        return [Facets$Showside.toMinPriceFacet(price)];
      }), Belt_Option.mapWithDefault(filters.maxPrice, [], function (price) {
        return [Facets$Showside.toMaxPriceFacet(price)];
      })]).join(", ");
    });
    Belt_Option.forEach(filtersNames, function (filtersNames) {
      Curry.app(trackEvent, [{
        NAME: "filter applied",
        VAL: filtersNames
      }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    });
    var tmp;
    if (typeof route === "number") {
      tmp = route;
    } else {
      switch (route.TAG | 0) {
        case /* Home */0:
          var data = route._0;
          tmp = {
            TAG: /* Home */0,
            _0: {
              homeType: data.homeType,
              filters: isEmpty ? undefined : filters,
              sort: data.sort
            }
          };
          break;
        case /* ListPage */1:
          var data$1 = route._0;
          tmp = {
            TAG: /* ListPage */1,
            _0: {
              listPageType: data$1.listPageType,
              viewPLP: data$1.viewPLP,
              filters: isEmpty ? undefined : filters,
              sort: data$1.sort
            }
          };
          break;
        default:
          tmp = route;
      }
    }
    Curry._3(goTo, undefined, true, tmp);
  }, [isMobile, goTo, listPageType, match$1.productSort, match$1.productFilters]);
  var handleSmartCardClick = React.useCallback(function (category) {
    var match = category.displayPriority;
    Curry._3(goTo, undefined, undefined, {
      TAG: /* ListPage */1,
      _0: {
        listPageType: {
          TAG: /* Category */0,
          _0: category.id
        },
        viewPLP: match ? false : true,
        filters: undefined,
        sort: undefined
      }
    });
  }, [goTo]);
  var handleSectionTitleClick = React.useCallback(function (category) {
    var isQuickView = Category$Showside.isQuickView(category);
    Curry.app(trackEvent, [isQuickView ? "slider:promo title" : "slider:title", true, category, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    Curry._1(handleCategoryClick, category);
  }, [trackEvent, handleCategoryClick]);
  var handleSectionLinkClick = React.useCallback(function (category) {
    var isConnected = Category$Showside.ExternalConnection.isConnectedToProductSource(category);
    var hasSubCategories = Category$Showside.hasSubCategories(category);
    if (isConnected) {
      if (hasSubCategories) {
        return Curry._1(handleSmartCardClick, category);
      } else {
        return Curry._1(handleCategoryClick, category);
      }
    }
  }, [handleSmartCardClick, handleCategoryClick]);
  var match$9 = UseMarkets$Showside.useMarkets(Belt_Option.map(Belt_Option.flatMap(attributes, function (attr) {
    return attr.currency;
  }), function (currency) {
    return {
      TAG: /* Currency */0,
      _0: currency
    };
  }), config.id, config.settings.currencyPickerEnabled, undefined);
  var handleMarketChange = match$9[2];
  var market = match$9[1];
  var allMarkets = match$9[0];
  var handleOverlayProductClick = React.useCallback(function (category) {
    return function (parentCategory, product, variant) {
      return Curry._3(goTo, undefined, undefined, {
        TAG: /* QuickView */3,
        _0: {
          mediaId: category.id,
          mediaParentId: Belt_Option.map(parentCategory, function (c) {
            return c.id;
          }),
          albumId: undefined,
          productId: product.id,
          relatedMediaProductIds: undefined,
          relatedMediaCategoryId: undefined,
          variantId: Belt_Option.map(variant, function (variant) {
            return variant.id;
          }),
          panelClosed: undefined,
          zoomedPhotoIndex: undefined,
          time: undefined
        }
      });
    };
  }, [goTo]);
  React.useEffect(function () {
    if (activeCategory !== undefined) {
      UseTracking$Showside.trackRetargeting(config.transitiveAccount, config.id, activeCategory, undefined, undefined, isMobile, undefined, undefined, undefined, undefined, Belt_Option.map(Category$Showside.ExternalConnection.getStoreCategoryConnection(activeCategory), function (connection) {
        return connection.count;
      }), "view_category");
    }
  }, [Belt_Option.map(activeCategory, function (cat) {
    return cat.id;
  })]);
  var handleProductFormChange = React.useCallback(function (product) {
    return function (variant) {
      if (typeof route !== "number" && route.TAG === /* QuickView */3) {
        var payload = route._0;
        return Curry._3(goTo, undefined, true, {
          TAG: /* QuickView */3,
          _0: {
            mediaId: payload.mediaId,
            mediaParentId: payload.mediaParentId,
            albumId: payload.albumId,
            productId: product.id,
            relatedMediaProductIds: payload.relatedMediaProductIds,
            relatedMediaCategoryId: payload.relatedMediaCategoryId,
            variantId: Belt_Option.map(variant, function (param) {
              return param.id;
            }),
            panelClosed: payload.panelClosed,
            zoomedPhotoIndex: payload.zoomedPhotoIndex,
            time: payload.time
          }
        });
      }
      return Curry._3(goTo, undefined, true, {
        TAG: /* PDP */2,
        _0: {
          categoryId: Belt_Option.flatMap(listPageType, function (id) {
            if (typeof id === "number" || id.TAG !== /* Category */0) {
              return;
            } else {
              return id._0;
            }
          }),
          productCategoryId: product.categoryId,
          productId: product.id,
          variantId: Belt_Option.map(variant, function (param) {
            return param.id;
          }),
          zoomedPhotoIndex: undefined
        }
      });
    };
  }, [route, listPageType]);
  var handleProductFormSubmit = React.useCallback(function (submission) {
    if (submission.TAG !== /* AllGood */0) {
      return Promise.resolve(undefined);
    }
    var match = submission._0;
    var match$1 = match.submitButtonType;
    if (typeof match$1 === "number") {
      if (match$1 !== 0) {
        handleOpenLink(undefined, undefined, match.product, match.variant, undefined);
        return Promise.resolve(undefined);
      } else {
        Curry._4(onAddToCart, match.product, match.variant, match.quantity, undefined);
        return new Promise(function (resolve, reject) {
          setTimeout(function (param) {
            resolve(config.settings.pdpAddToCartConfirmation);
          }, 1000);
        });
      }
    }
    var confirmation = match$1.confirmation;
    Curry._3(match$1.run, match.product, match.variant, match.quantity);
    if (confirmation !== undefined) {
      return new Promise(function (resolve, reject) {
        setTimeout(function (param) {
          resolve(confirmation);
        }, 1000);
      });
    } else {
      return Promise.resolve(undefined);
    }
  }, [config.settings.pdpAddToCartConfirmation, handleOpenLink, onAddToCart]);
  var ctxValue = React.useMemo(function () {
    return {
      smartnavApiHost: smartnavApiHost,
      embedType: embedType,
      isSidebarOpen: isSidebarOpen,
      isMobileFiltersOpen: isMobileFiltersOpen,
      lastProductAddedToCart: lastProductAddedToCart,
      setLastProductAddedToCart: setLastProductAddedToCart,
      trackEvent: trackEvent,
      toggleSidebar: toggleSidebar,
      toggleFiltersPanel: toggleFiltersPanel,
      onAddToCart: onAddToCart,
      onCategoryClick: handleCategoryClick,
      onPureCategoryClick: handlePureCategoryClick,
      onQuickViewClick: handleQuickViewClick,
      onProductClick: handleProductClick,
      onHomeClick: handleHomeClicked,
      onFavoritesClick: handleFavoritesClicked,
      onHistoryClick: handleHistoryClicked,
      onLauncherItemClick: handleLauncherItemClick,
      onSectionTitleClick: handleSectionTitleClick,
      onSectionLinkClick: handleSectionLinkClick,
      onSmartCardClick: handleSmartCardClick,
      onDrawerOpening: handleDrawerOpening,
      onChangeFilters: handleChangeFilters,
      onChangeSort: handleChangeSort,
      onCloseNavigation: handleCloseNavigation,
      onOverlayProductClick: handleOverlayProductClick,
      onOpenLink: handleOpenLink,
      onBackClick: handleBackClick,
      onProductFormChange: handleProductFormChange,
      onProductFormSubmit: handleProductFormSubmit,
      redirectToLink: redirectToLink,
      getLinkerParam: getLinkerParam,
      isMiniPDPVisible: isMiniPDPVisible,
      allMarkets: allMarkets,
      market: market,
      onMarketChange: handleMarketChange
    };
  }, [match$8.cart, lastProductAddedToCart, toggleSidebar, trackEvent, onAddToCart, handleCategoryClick, handleChangeSort, handleQuickViewClick, handleProductClick, handleHomeClicked, handleMarketChange, handleOverlayProductClick, handleCloseNavigation, handleProductFormChange, handleProductFormSubmit, market]);
  return React.createElement(EntrypointContext$Showside.Provider.make, {
    value: ctxValue,
    children: children
  });
}
EntrypointCallbacks.displayName = "EntrypointCallbacks";
var make = EntrypointCallbacks;
export { make };
/* react Not a pure module */